import { type TripWorkspace, type TripPlanItem } from "./trip";
export type PastedStop = {
	localKey?: string;
	day: number | null;
	title: string;
	time: string | null;
};
export function parsePastedTrip(text: string, startDate: string): PastedStop[] {
	if (text.length > 50000) throw new Error("PASTE_TOO_LONG");
	let day: number | null = null;
	const rows: PastedStop[] = [];
	for (let line of text
		.split(/\r?\n/)
		.map((x) => x.trim())
		.filter(Boolean)
		.slice(0, 500)) {
		const marker = line.match(/^(?:([0-9]{1,2})\s*일차|Day\s*([0-9]{1,2}))/i);
		if (marker) {
			day = Number(marker[1] ?? marker[2]) - 1;
			line = line.slice(marker[0].length).trim();
		} else {
			const date = line.match(
				/^(?:(\d{4})[\/.-])?(\d{1,2})(?:월\s*|[\/.-])(\d{1,2})(?:일)?/,
			);
			if (date) {
				const year = Number(date[1] ?? startDate.slice(0, 4));
				const parsed = new Date(
					Date.UTC(year, Number(date[2]) - 1, Number(date[3])),
				);
				const diff = Math.round(
					(parsed.getTime() - Date.parse(`${startDate}T00:00:00Z`)) / 86400000,
				);
				day = diff >= 0 && diff < 31 ? diff : null;
				line = line.slice(date[0].length).trim();
			}
		}
		if (!line) continue;
		const time = line.match(/(?:^|[\s\t])([01]?\d|2[0-3]):([0-5]\d)(?:\s|$)/);
		const title = (time ? line.replace(time[0], " ") : line)
			.replace(/^[\s\t·•*-]+/, "")
			.replaceAll("\t", " ")
			.trim()
			.slice(0, 80);
		if (!title) continue;
		rows.push({
			day: day !== null && day >= 0 && day < 31 ? day : null,
			title,
			time: time ? `${time[1]!.padStart(2, "0")}:${time[2]}` : null,
		});
	}
	return rows;
}
export function applyPastedTrip(trip: TripWorkspace, rows: PastedStop[]) {
	const copy = structuredClone(trip);
	copy.days.forEach((d) => (d.items = []));
	copy.candidates = [];
	rows.forEach((row) => {
		const item: TripPlanItem = {
			id: crypto.randomUUID(),
			title: row.title,
			type: "spot",
			area: copy.destinationCity,
			time: row.time,
			estimateJpy: null,
			mapQuery: `${row.title} ${copy.destinationCity}`,
			note: null,
			completed: false,
		};
		const day = row.day === null ? null : copy.days[row.day];
		if (day) day.items.push(item);
		else copy.candidates!.push(item);
	});
	return copy;
}
